export default "__VITE_ASSET__HwmtChbx__"